export default __webpack_public_path__ + "static/screen_phone_multiplayer-6ad2fdf2eb2ba521c35c53c370d79961.png";